<template>
  <div class="homePage">
      <div>
        <HomePage v-if="active == 0"></HomePage>
        <Purchase v-if="active == 1"></Purchase>
        <Sale v-if="active == 2"></Sale>
        <Store v-if="active == 3"></Store>
        <Manufactor v-if="active == 4"></Manufactor>
        
        <UserInfo v-if="active == 5"></UserInfo>
      </div>
      <van-tabbar v-model="active" style="z-index:999">
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item icon="bookmark">采购管理</van-tabbar-item>
        <van-tabbar-item icon="bookmark">销售管理</van-tabbar-item>
        
        <van-tabbar-item icon="bookmark">仓储管理</van-tabbar-item>
        <van-tabbar-item icon="todo-list">生产管理</van-tabbar-item>
        <van-tabbar-item icon="manager-o" >我</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import UserInfo from '../my/index.vue'
import Vue from 'vue';
import { Tabbar,TabbarItem } from 'vant';
import {router}  from '../../router'
import Purchase from './modulePage/purchase'
import Sale from './modulePage/sale'
import Store from './modulePage/store'
import Manufactor from './modulePage/manufactor'
import HomePage from '../bussComponents/homePage'

Vue.use(Tabbar);
Vue.use(TabbarItem);

export default {
  components: {
    Tabbar, 
    TabbarItem,
    UserInfo,
    HomePage,
    Purchase,
    Sale,
    Manufactor,
    Store
  },
  computed: {
  },
  data() {
    return {
      active: 0,
    };
  },
  mounted(){
    var params =  window.location.href.split('active=');// this.$router.query;
    if(params.length == 1){
      this.active = 0;
    }
    else{
      this.active = parseInt(params[1]);
    }
    this.$forceUpdate();
  },
  methods: {
    logout(){
    },
    goHome(){
      this.active = -1;
    }
  }
};
</script>

